import type { Environment } from '@change-corgi/config/environments';

import { optimizelyProjectIds } from './data';

export function getOptimizelyProjectId(environment: Environment): string {
	// eslint-disable-next-line security/detect-object-injection
	return optimizelyProjectIds[environment];
}
